import { push } from 'connected-react-router'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { ROUTES } from '../../../common/Routes/routePaths'
import api from '../../../services/api.services'
import { startResetPassword } from './ForgotPasswordActions'
import { getErrorMsg } from '../../../common/helpers/translations'

function* sagaStartResetPassword({ payload }: any) {
  try {
    const { email } = payload
    yield call(api.auth.startResetPassword, { email })
    const notification: INotification = {
      type: 'success',
      content: t`We sent a password change link to your email`,
    }
    yield put(push(ROUTES.LOGIN.to, { notification }))
  } catch (e: any) {
    const startResetPasswordErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('password reset start'),
    }

    yield put({ type: String(addNotification), payload: startResetPasswordErrorNotification })
  }
}

export function* forgotPasswordSagas() {
  yield all([takeEvery(String(startResetPassword), sagaStartResetPassword)])
}
